document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".sustainability-mission-bison");

  sections.forEach(function (section) {
    const btn = section.querySelector(".sustainability-mission-bison__read-more-btn");
    const moreText = section.querySelector(".sustainability-mission-bison__more-text");

    if (!btn || !moreText) return;

    btn.addEventListener("click", function (event) {
      event.preventDefault();
      const isExpanded = moreText.style.display === "inline";
      const readMoreLabel = btn.dataset.readMoreLabel || "Read more";
      const readLessLabel = btn.dataset.readLessLabel || "Read less";

      moreText.style.display = isExpanded ? "none" : "inline";
      btn.textContent = isExpanded ? readMoreLabel : readLessLabel;
    });
  });
});
